module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPlatinum.069c41d.webp";